import React from "react";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, FormLabel, FormCheck } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { authService } from "services/authService";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";

class RegisterCompanyModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			user: {
				name: "",
				surname: "",
				company: "",
				code: "",
				email: "",
				password: "",
				confirmPassword: "",
			},
		};
	}

	validateForm() {
		const { user } = this.state;
		return user.password.length > 5 && user.password === user.confirmPassword;
	}

	handleChange = (event) => {
		const { user } = this.state;
		this.setState({
			user: {
				...user,
				[event.target.id]: event.target.value,
			},
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		this.setState({ isLoading: true });

		const { user } = this.state;
		const response = await authService.signup({
			...user,
			domain: window.location.hostname,
		});

		if (response.ok) {
			toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
			this.props.handleClose();
			if (this.props.onSuccess) this.props.onSuccess();
		} else {
			this.setState({
				submitted: true,
				isLoading: false,
				errors: errorFormating(response),
			});
		}
	};

	render() {
		const { user, errors } = this.state;

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<FormGroup controlId="name" className="form-group">
						<FormLabel>
							{this.props.t('registerCompany.name')} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							autoFocus
							type="text"
							value={user.name}
							placeholder={this.props.t('registerCompany.namePlaceholder')}
							onChange={this.handleChange}
							isInvalid={this.checkValidField("name")}
						/>
						<FormControl.Feedback type="invalid">{errors.name}</FormControl.Feedback>
					</FormGroup>

					<FormGroup controlId="surname" className="form-group">
						<FormLabel>
							{this.props.t('registerCompany.surname')} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							type="text"
							value={user.surname}
							placeholder={this.props.t('registerCompany.surnamePlaceholder')}
							onChange={this.handleChange}
							isInvalid={this.checkValidField("surname")}
						/>
						<FormControl.Feedback type="invalid">{errors.surname}</FormControl.Feedback>
					</FormGroup>

					<FormGroup controlId="company" className="form-group">
						<FormLabel>
							{this.props.t('registerCompany.company')} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							type="text"
							value={user.company}
							placeholder={this.props.t('registerCompany.companyPlaceholder')}
							onChange={this.handleChange}
							isInvalid={this.checkValidField("company")}
						/>
						<FormControl.Feedback type="invalid">{errors.company}</FormControl.Feedback>
					</FormGroup>

					<FormGroup controlId="code" className="form-group">
						<FormLabel>{this.props.t('registerCompany.companyCode')}</FormLabel>
						<FormControl
							type="text"
							value={user.code}
							placeholder={this.props.t('registerCompany.companyCodePlaceholder')}
							onChange={this.handleChange}
							isInvalid={this.checkValidField("code")}
						/>
						<FormControl.Feedback type="invalid">{errors.code}</FormControl.Feedback>
					</FormGroup>

					<FormGroup controlId="email" className="form-group">
						<FormLabel>
							{this.props.t('registerCompany.email')} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							type="email"
							value={user.email}
							placeholder={this.props.t('registerCompany.emailPlaceholder')}
							onChange={this.handleChange}
							isInvalid={this.checkValidField("email")}
						/>
						<FormControl.Feedback type="invalid">{errors.email}</FormControl.Feedback>
					</FormGroup>

					<FormGroup controlId="password" className="form-group">
						<FormLabel>
							{this.props.t('registerCompany.password')} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							type="password"
							value={user.password}
							placeholder={this.props.t('registerCompany.password')}
							onChange={this.handleChange}
							isInvalid={this.checkValidField("password")}
						/>
						<FormControl.Feedback type="invalid">{errors.password}</FormControl.Feedback>
					</FormGroup>

					<FormGroup controlId="confirmPassword" className="form-group">
						<FormLabel>
							{this.props.t('registerCompany.repeatPassword')} <span className="label-required">*</span>
						</FormLabel>
						<FormControl
							type="password"
							value={user.confirmPassword}
							placeholder={this.props.t('registerCompany.repeatPassword')}
							onChange={this.handleChange}
							isInvalid={this.checkValidField("confirmPassword")}
						/>
						<FormControl.Feedback type="invalid">
							{errors.confirmPassword}
						</FormControl.Feedback>
					</FormGroup>

					{errors.general && (
						<div className="alert alert-danger">{errors.general}</div>
					)}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{this.props.t('common.cancel')}
					</button>
					<SubmitButton
						type="submit"
						disabled={!this.validateForm()}
						isLoading={this.state.isLoading}
						text={this.props.t('registerCompany.submit')}
						loadingText={this.props.t('registerCompany.submitting')}
					/>
				</div>
			</form>
		);
	}
}

export default withTranslation()(RegisterCompanyModal);
